import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AnnotationService {
  API_SERVER: string = environment.baseApiUrl;
  reloadTable$ = new BehaviorSubject(false);

  constructor(private httpClient: HttpClient) {}

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  findAll(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient.get(this.API_SERVER + 'annotation', {
      params: Params,
    });
  }

  createAnnotation(data): Observable<any> {
    return this.httpClient.post(this.API_SERVER + 'annotation', data);
  }

  update(id: string, data): Observable<any> {
    return this.httpClient.put(`${this.API_SERVER}annotation/${id}`, data);
  }

  findOne(id: string): Observable<any> {
    return this.httpClient.get(`${this.API_SERVER}annotation/${id}`);
  }

  findImagesRelatedToCoor(
    assetName: string,
    longlitude: number,
    latitude: number
  ): Observable<any> {
    // return this.httpClient.get(`https://proxy.aerodyne.dev/https://us-central1-latlongmapping-83f20.cloudfunctions.net/getImageData?lat=${latitude}&long=${longlitude}`);
    const points = [{ lat: latitude, long: longlitude }];
    return this.httpClient.get(
      `https://us-central1-latlongmapping-83f20.cloudfunctions.net/orthoLatLongtoImgArr?assetName=${assetName}&arrPts=${JSON.stringify(
        points
      )}`
    );
  }

  findImagesRelatedToCoorMultiPoints(
    assetName: string,
    geometry: any
  ): Observable<any> {
    let points = [];
    geometry.coordinates[0].forEach((point) => {
      const p = { lat: point[1], long: point[0] };
      points.push(p);
    });
    const endpoint = `https://us-central1-latlongmapping-83f20.cloudfunctions.net/orthoLatLongtoImgArr?assetName=${assetName}&arrPts=${JSON.stringify(
      points
    )}`;
    return this.httpClient.get(endpoint);
  }

  // findOneByProjectID(id: string): Observable<any> {
  //   return this.httpClient.get(
  //     `${this.API_SERVER}annotation?filtered[0][key]=location&filtered[0][val]=${id}`
  //   );
  // }

  remove(id): Observable<any> {
    return this.httpClient.delete(this.API_SERVER + `annotation/${id}`);
  }

  restore(id): Observable<any> {
    return this.httpClient.delete(this.API_SERVER + `annotation/restore/${id}`);
  }

  findDefectCount(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient.get(`${this.API_SERVER}annotation/defects-count`, {
      params: Params,
    });
  }

  bulkUpdateReviewStatus(data) {
    return this.httpClient.put(
      `${this.API_SERVER}annotation/bulkUpdateReviewStatus`,
      data
    );
  }
}
